import Vue from 'vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import BaseIconButton from 'src/components/ui/BaseIconButton.vue'

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
Vue.component('BaseIconButton', BaseIconButton)


// WEBPACK FOOTER //
// ./src/plugins/global-component.js